// run command
// ($env:HTTPS = "true") -and (npm start)
//($env:HTTPS = "true") -and (npm start npx react-scripts --openssl-legacy-provider start)
// npx react-scripts --openssl-legacy-provider start
// npx react-scripts --openssl-legacy-provider build
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./Responsive.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import { PrimeReactProvider } from 'primereact/api';

ReactDOM.render(
  <BrowserRouter>
    <Auth0Provider

      // domain="https://auth.qrcode-stt.com"
      // clientId="eFUzj7wsznaRtOuc5Mrc4ftimokSvg3Z"
    
      // Loved On STT Web Local
      // domain="https://auth.qrcode-stt.com"
      // clientId="e27DRhb0iogK9S7fOEbOnEXpiRnRMx4k"

      //LovedQrcodeTest Live
      domain="https://auth.qrcode-stt.com"
      clientId="F4oLqJiw3AEU93RIAMe7rCIIhw4ZpWSa"

      redirectUri={window.location.origin + "/Authcallback"}

      //Loved one
      audience="https://api.lifetags.io/weatherforecast"
      //audience="https://api.qrcode-stt.com/weatherforecast"
      scope="openid profile email"
    >
      <PrimeReactProvider>
        <App />
      </PrimeReactProvider>

    </Auth0Provider>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
